import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-lot-add-photo-images-sorter-item',
  templateUrl: './lot-add-photo-images-sorter-item.component.html',
  styleUrls: ['./lot-add-photo-images-sorter-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoImagesSorterItemComponent {
  @Input() image: string;
  @Input() index: number | null;
  @Input() lastIndex: number | null;
  @Input() isAuctionList = false;
  @Output() selected = new EventEmitter<string>();
  @Output() unselected = new EventEmitter<string>();

  get canUnselect(): boolean {
    return this.isSelected && this.index === this.lastIndex;
  }

  get isSelected(): boolean {
    return this.index !== null;
  }

  get renderOverlay(): boolean {
    return this.isSelected;
  }

  @HostBinding('style.cursor')
  get cursor(): string {
    return this.isSelected && !this.canUnselect ? 'not-allowed' : 'pointer';
  }

  @HostListener('mousedown')
  toggleSelected(): void {
    if (this.canUnselect) {
      this.unselected.emit(this.image);
    } else if (!this.isSelected) {
      this.selected.emit(this.image);
    }
  }
}
